export const ROMBELS_GET = 'ROMBELS_GET';
export const ROMBEL_PORTALUSERS_GET = 'ROMBEL_PORTALUSERS_GET';
export const ROMBEL_UPDATE_PORTALUSER = 'ROMBEL_UPDATE_PORTALUSER';
export const ROMBEL_ADD = 'ROMBEL_ADD';
export const ROMBEL_EDIT = 'ROMBEL_EDIT';
export const ROMBEL_GET = 'ROMBEL_GET';
export const ROMBEL_DELETE = 'ROMBEL_DELETE';
